import React, { useState, FunctionComponent } from 'react';
import { Button, Dialog } from 'shamrock-clover-ui';
import styles from './trialPopupModal.scss';
import creditIcon from '../../assets/images/creditIcon.svg'
import ptIcon from '../../assets/images/ptIcon.svg'
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const SHOW_TRIAL_PATH = 'showTrialPath';
export const TrialPopupModal: FunctionComponent = () => {
  const userStatus = useSelector((state: any) => state.app.user.userStatus);
  const isTrialActive = userStatus.isTrial && userStatus.trialState === 'ACTIVE';
  const [showModal, setShowModal] = useState(isTrialActive && !localStorage.getItem(SHOW_TRIAL_PATH));
  const { t } = useTranslation('common', { keyPrefix: 'trialModalPathSelection' });

  const productProps = [
    {
      icon: creditIcon,
      title: t('credit_title'),
      text: t('credit_text')
    },
    {
      icon: ptIcon,
      title: t('pt_title'),
      text: t('pt_text')
    }
  ]

  const onClick = () => {
    localStorage.setItem(SHOW_TRIAL_PATH, 'true');
    setShowModal(false);
  };

  return (
    <div className={styles.dialogWrapper}>
      <Dialog open={Boolean(showModal)} width='708px' closeOnBackdropClick onClose={onClick} content={
        <>
          <div className={styles.titleSection}>
            <div >
              <h2 className={styles.title}>{t('welcome')}</h2>
              <hr className={styles.separator} />
            </div>
          </div>
          <p className={styles.description}>{t('description')}</p>
          <div className={styles.productsContainer}>
            {productProps.map((product) => {
              return <div key={product.title} className={styles.productContainer} >
                <img alt={`${product.title}-icon`} src={product.icon} className={styles.icon} />
                <div>
                  <p className={styles.productTitle}>
                    {product.title}
                  </p>
                  <p className={styles.productText}>
                    {product.text}
                  </p>
                </div>
              </div>
            })}
          </div>
          <Button className={styles.buttonStyle} onClick={onClick}>
            {t('start_exploring')}
          </Button>
        </>
      } />
    </div>
  );
};
